/**
 * Labelled section divider used to separate the inductee's two groups of
 * work: what they complete themselves ahead of time, and what gets sorted
 * at a desk on the day. Centered title with a one-line hint underneath.
 */
export function GroupDivider({ title, hint }: { title: string; hint: string }) {
  return (
    <div className="pt-3">
      <div className="flex items-center gap-3">
        <div className="h-px flex-1 bg-line/10" />
        <span className="text-xs font-semibold uppercase tracking-wider text-fg-dim">
          {title}
        </span>
        <div className="h-px flex-1 bg-line/10" />
      </div>
      <p className="mt-2 text-center text-xs text-fg-muted">{hint}</p>
    </div>
  );
}
